import {definePreset, palette} from "@primeng/themes";
import Aura from "@primeng/themes/aura";

export const themePreset = definePreset(Aura, {
    semantic: {
        primary: palette("#007bc1"),
    },
    components: {
        progressspinner: {
            root: {
                "color-1": "{primary.500} !important",
                "color-2": "{primary.500} !important",
                "color-3": "{primary.500} !important",
                "color-4": "{primary.500} !important"
            }
        }
    }
});
